import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import './Addproductimagemodal.scss';
import img1 from './cap.png';
import img2 from './cap.png';
import img3 from './cap.png';

interface AddProductImageModalProps {
    isOpen: boolean;
    toggle: () => void;
}

const AddproductimaegModal: React.FC<AddProductImageModalProps> = ({ isOpen, toggle }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered className="product-image-modal">
            <ModalBody className='bodymodal'>
                <button className="close-modal-btn" onClick={toggle}>
                    <i className='bx bx-x'></i>
                </button>
                <div className="modal-preview-wrapper">
                    <h5 className="modal-title">Image Preview</h5>
                    <div className="main-image">
                        <img src={img1} alt="Main Bag" />
                    </div>

                    <div className="by-pass-text">
                        <span>✨Buypass generated images</span>
                        <p>Use these images to 10x your conversions</p>
                    </div>

                    <div className="generated-images">
                        <div className="img-box">
                            <img src={img2} alt="Generated 1" />
                            <div className="use-img-card">
                                <button className="use-image-btn">⭐ Use this image</button>
                                <button className="use-image-btn"><i className='bx bx-download'></i></button>
                            </div>
                        </div>
                        <div className="img-box">
                            <img src={img3} alt="Generated 2" />
                            <div className="use-img-card">
                                <button className="use-image-btn">⭐ Use this image</button>
                                <button className="use-image-btn"><i className='bx bx-download'></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default AddproductimaegModal;
